import {AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {Route} from '../../enum/route';
import {combineLatest, map, Observable} from 'rxjs';
import {DialogTwoOptionsComponent} from '../../components/dialogs/two-options-dialog/dialog-two-options.component';
import {Store} from '@ngrx/store';
import {Company} from '../../model/proposal/company';
import {CompanyFormBase} from '../../components/create-company/company-form-base/company-form-base.component';
import {CompanyService} from '../../services/company-service/company.service';
import {CompanyAppState} from '../../store/company/reducers/company.reducer';
import {AuthService} from '../../services/auth/auth.service';
import {MyCompanyActions} from '../../store/company/actions/company.actions';
import {UserAppState} from '../../store/user/reducers/user.reducer';
import {selectUserRoles} from '../../store/auth/selectors/auth.selectors';
import {Roles} from '../../enum/roles';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Component({
    selector: 'app-onboarding-company',
    templateUrl: './onboarding-company.component.html',
    styleUrls: ['onboarding-company.component.scss', '../../../styles/create-something.scss', '../../../styles/standard-elements.scss',],
    standalone: false
})
export class OnboardingCompanyComponent implements OnInit, AfterViewInit {
  idNames = [];
  scrolled = 0;
  maxScrolled = 0;
  scrollPosition = [0];
  company = new Company();
  titles = ['addressInformation',
    'contactInformation',
  ];
  saveCompanyButtonDisabled: boolean = false;

  childFormValid: boolean[] = [];

  allFormsValid$: Observable<boolean>;
  validChildForm: Observable<boolean>[] = [];

  userRoles = [];

  @ViewChildren(CompanyFormBase) formComponents: QueryList<CompanyFormBase>;

  constructor(private readonly translate: TranslateService,
              private readonly dialog: MatDialog,
              private readonly router: Router,
              private readonly companyService: CompanyService,
              private readonly changeDetector: ChangeDetectorRef,
              private readonly companyStore: Store<CompanyAppState>,
              private readonly authService: AuthService,
              private readonly userStore: Store<UserAppState>,
  ) {
  }

  ngOnInit() {
    this.company.name = this.authService.getCompanyNameFromAccessToken();
    for (let i = 0; i < this.titles.length; i++) {
      this.idNames.push('question-block' + i);
      this.childFormValid.push(false);
    }

    this.userStore.select(selectUserRoles).subscribe(roles => this.userRoles = roles);
  }


  scroll(id) {
    document.getElementById(id).scrollIntoView();
  }

  onWindowScroll(el: HTMLElement) {
    // margin must be equal to the one given in style class form-outer-container
    const margin = 64;
    this.scrollPosition = [0];
    let scrollTop = el.scrollTop + window.innerHeight / 3;
    for (let childrenKey in el.children) {
      this.scrollPosition.push(el.children[childrenKey].scrollHeight + margin + this.scrollPosition[this.scrollPosition.length - 1]);
    }
    this.scrolled = 0;
    for (let i = 1; i < this.scrollPosition.length; i++) {
      if (scrollTop > this.scrollPosition[i] && this.titles[i]) {
        this.scrolled = i;
      }
    }
    this.maxScrolled = Math.max(this.maxScrolled, this.scrolled);
    this.scroll(this.idNames[this.scrolled] + 'button');
  }

  openConfirmationMatDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: this.translate.instant('createCompany.confirmation.title'),
      optionCancel: this.translate.instant('createCompany.confirmation.no'),
      optionConfirm: this.translate.instant('createCompany.confirmation.yes'),
    };
    const dialogRef = this.dialog.open(DialogTwoOptionsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveCompany();
        this.saveCompanyButtonDisabled = true;
      }

    });
  }

  saveCompany() {
    for (let form of this.formComponents) {
      form.updateCompany(this.company);
    }
    this.companyService.saveCompany(this.company).subscribe((company: Company) => {
      this.companyStore.dispatch(MyCompanyActions.loaded({company: company}));
      if (this.userRoles.includes(Roles.ROLE_DIRECT_CORPORATE_ADMIN)
          || this.userRoles.includes(Roles.ROLE_REPRESENTATIVE)
          || this.userRoles.includes(Roles.ROLE_ASSOCIATION_ADMIN)) {
        let navigateUrl: string = `/${Route.COMPANY_PROFILE}/${company?.companyId}`;
        this.router.navigateByUrl(navigateUrl).then();
      } else {
        this.router.navigate(['/' + Route.INSERATE]).then();
      }
    });
  }

  ngAfterViewInit(): void {
    const obs: Observable<boolean>[] = [];
    for (let formbase of this.formComponents) {
      obs.push(formbase.validStatus());
      this.validChildForm.push(formbase.validStatus());
    }
    this.allFormsValid$ = combineLatest(obs)
      .pipe(
        map((array: boolean[]) => array.every(value => value)),
      );
    this.changeDetector.detectChanges();
  }

  logout() {
    this.authService.logout();
  }
}
